import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, errMsg, setCoachToken } from "../../lib/api";
import { track } from "../../lib/analytics";

const input = "mt-1 w-full border-2 border-slate-200 px-3 py-2.5 text-sm font-semibold outline-none focus:border-slate-900";

export const CoachAuth = ({ onDone, initialMode = "login" }) => {
  const [mode, setMode] = useState(initialMode);
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const body = mode === "login" ? { email: f.email, password: f.password } : f;
      const { data } = await api.post(`/auth/${mode === "login" ? "login" : "register"}`, body);
      setCoachToken(data.token);
      if (mode === "register") track("sign_up", { method: "email" });
      onDone(data.user);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  const field = (k, label, props) => (
    <label className="block text-xs font-bold uppercase tracking-wider text-slate-600">{label}
      <input {...props} required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={input} data-testid={`coach-${k}-input`} />
    </label>
  );
  return (
    <form onSubmit={submit} className="mx-auto w-full max-w-sm space-y-4 border-2 border-slate-900 bg-white p-6 shadow-[6px_6px_0_0_#0f172a]" data-testid="coach-auth-form">
      <div className="grid grid-cols-2 gap-1">
        {[["login", "Sign in"], ["register", "Create account"]].map(([m, l]) => (
          <button key={m} type="button" onClick={() => { setMode(m); setError(""); }} data-testid={`coach-tab-${m}`}
            className={`py-2 text-xs font-bold uppercase ${mode === m ? "bg-slate-900 text-white" : "border-2 border-slate-200"}`}>{l}</button>
        ))}
      </div>
      <h2 className="font-display text-2xl font-black uppercase">{mode === "login" ? "Coach sign in" : "New coach account"}</h2>
      {mode === "register" && field("name", "Your name", { maxLength: 80 })}
      {field("email", "Email", { type: "email" })}
      {field("password", mode === "register" ? "Password (8+ characters)" : "Password", { type: "password", minLength: mode === "register" ? 8 : undefined })}
      {error && <p className="text-sm text-red-600" data-testid="coach-auth-error">{error}</p>}
      <button type="submit" disabled={busy} className="btn-blaze flex w-full items-center justify-center gap-2 px-4 py-2.5 text-sm" data-testid="coach-auth-submit">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} {mode === "login" ? "Sign in" : "Create account"}
      </button>
      <p className="text-center text-[11px] text-slate-500">By continuing you agree to how we handle data in our <a href="/privacy" className="underline" data-testid="coach-privacy-link">privacy policy</a>.</p>
    </form>
  );
};
